<app-header-title>
  <span title>{{'publicsetting.jobTitleStructure'|translate}}</span>
</app-header-title>


<div class="publicsetting"  style="padding: 0rem 3rem;">
  <dx-data-grid #grid class="dx-card wide-card" 
    [dataSource]="customDataSource"
    [showBorders]="false"
    [focusedRowEnabled]="true"
    [focusedRowIndex]="0"
    [allowColumnResizing]="true"
    [columnAutoWidth]="true"
     [columnHidingEnabled]="true"
    [showColumnLines]="false"
    [rowAlternationEnabled]="true"
    [showRowLines]="false"
    [showBorders]="false"
    [errorRowEnabled]="false"
    [rtlEnabled]="currentLang=='ar'?true:false"
    (onEditingStart)="jobtitle($event)"
    (onInitNewRow)="jobtitle($event)"
    style="width: 100%"
    >
    <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
    <dxo-pager [visible]="true"></dxo-pager>
      <dxo-editing
      [useIcons]="false"
      [allowAdding]="true"
      [allowDeleting]="true"
      [allowUpdating]="true"
      [texts]="button"
      >
      <dxo-texts [addRow]="addrowfun('publicsetting.jobTitleStructure')"
      confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
  </dxo-editing>
  
  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
   
  <dxi-column dataField="managementId" caption="{{'addemployee.tab1.management'|translate}}">
    <dxo-lookup
      [dataSource]="managemetList"
      valueExpr="id"
      [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"    >
    </dxo-lookup>
  </dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>
      
  </dxi-column>
  </dx-data-grid>
</div>


